module.exports = require('./block');

module.exports.BlockHeader = require('./blockheader');
module.exports.MerkleBlock = require('./merkleblock');



//////////////////
// WEBPACK FOOTER
// ./~/bitcore-lib/lib/block/index.js
// module id = 1017
// module chunks = 0